import { TDispatch } from '../type';
import { TTruckerProfileState } from './truckerProfile.type';

export const truckerProfileReducer = (
  state: TTruckerProfileState,
  { type, payload }: TDispatch
): TTruckerProfileState => {
  switch (type) {
    case 'set_trucker_profile':
      return payload as TTruckerProfileState;
    default:
      return state;
  }
};

truckerProfileReducer.key = 'truckerProfile';
truckerProfileReducer.initialState = {};

export default { truckerProfileReducer };
